// PHA-543: shared layout constants used to stack sticky bars in the patient
// chart (app header → patient-tab strip → per-patient data tabs) and to pin
// the SmartHub rail. Kept in a leaf module to avoid a Dashboard ↔ PatientDetail
// circular import (Dashboard renders PatientTabContent renders PatientDetail).

// Pixel height of the sticky app header (Radix Flex py=4 + size-3 Button +
// 1px border).
export const APP_HEADER_HEIGHT = 72;

// Approx height of the patient-tab strip (10px*2 padding + ~20px content +
// 2px active border + 1px bottom border).
export const PATIENT_TAB_STRIP_HEIGHT = 44;

// Offset for content that should pin directly under both stacked bars.
export const PATIENT_CHART_STICKY_HEADER_OFFSET =
  APP_HEADER_HEIGHT + PATIENT_TAB_STRIP_HEIGHT;
